export default "<img src=\"../../assets/gif/loadbtnsura.gif\" alt=\"loading sura\" />\n";